import { render, staticRenderFns } from "./sale_customer_edit.vue?vue&type=template&id=f13a1314&scoped=true"
import script from "./sale_customer_edit.vue?vue&type=script&lang=js"
export * from "./sale_customer_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a1314",
  null
  
)

export default component.exports